import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { computed, onMounted, ref, onUnmounted, } from 'vue';
import { useRoute, useRouter, } from 'vue-router';
import { pageSizeOptionList } from '@/constants';
import storeListTableHeader from '@/constants/storeManagement/storeList';
import Item from '@/views/StoreManagement/StoreList/Item.vue';
import { tableScrollTop } from '@/utils/tableScrollTop';
import BrgPagination from '@/components/BrgPagination.vue';
import { sortTypeEnum } from '@/constants/global';
import vuexStore from '@/vuex-store';
import Select from '@/components/Form/Select.vue';
import TotalCount from '@/components/TotalCount.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'List',
    setup(__props) {
        const route = useRoute();
        const router = useRouter();
        let unsubscribe;
        const tableRef = ref(null);
        const sortBy = ref([
            {
                key: 'name',
                order: sortTypeEnum.ASC,
            },
        ]);
        const filterOption = computed(() => vuexStore.state.storeManagement.storeList.filterOption);
        const getterPaginationData = computed(() => vuexStore.getters['storeManagement/storeList/getterPaginationData']);
        const getterStoreList = computed(() => vuexStore.getters['storeManagement/storeList/getterStoreList']);
        const getterPageSize = computed(() => vuexStore.getters['storeManagement/storeList/getterPageSize']);
        const setFilterOption = (payload) => vuexStore.dispatch('storeManagement/storeList/setFilterOption', payload);
        const pageComputed = computed({
            get() {
                return getterPaginationData.value.pageNumber;
            },
            set(pageNumber) {
                setFilterOption({
                    pageNumber,
                });
            },
        });
        const handleUpdateSortBy = (value) => {
            sortBy.value = value;
            const { key, order, } = value[0];
            vuexStore.dispatch('storeManagement/storeList/setSortOption', [
                {
                    field: key,
                    value: order,
                },
            ]);
        };
        /**
         * 셀렉터 변경 핸들러
         */
        const handleChangeSelect = (selectType) => (selectOptionValue) => {
            if (!selectOptionValue) {
                return;
            }
            const { query } = route;
            const replaceParam = {
                query: {
                    ...query,
                    [selectType]: selectOptionValue,
                },
            };
            router.replace(replaceParam);
            const filterData = {
                [selectType]: selectOptionValue,
            };
            if (selectType === 'pageSizeType') {
                filterData.pageNumber = '1';
            }
            setFilterOption(filterData);
        };
        // 1. 엘리먼트 생성 후 실행
        onMounted(() => {
            unsubscribe = tableScrollTop(vuexStore, tableRef.value.$el);
        });
        // 2. 페이지 이탈시 구독 취소
        onUnmounted(() => {
            unsubscribe();
        });
        return (_ctx, _cache) => {
            const _component_v_data_table_server = _resolveComponent("v-data-table-server");
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(TotalCount, null, {
                    default: _withCtx(() => [
                        _createTextVNode(" 총 " + _toDisplayString(getterStoreList.value.length) + " 건 ", 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                }),
                _createVNode(_component_v_data_table_server, {
                    hover: "",
                    ref_key: "tableRef",
                    ref: tableRef,
                    class: "store-management-data-table brg-table",
                    "hide-default-footer": "",
                    "must-sort": "",
                    "fixed-header": "",
                    "no-data-text": _ctx.$t(`common.no_search_data_text`),
                    items: getterStoreList.value,
                    "items-per-page": getterPageSize.value,
                    headers: _unref(storeListTableHeader),
                    "items-length": -1,
                    "sort-by": sortBy.value,
                    density: "compact",
                    "onUpdate:sortBy": handleUpdateSortBy
                }, {
                    [`item`]: _withCtx(({ item }) => [
                        _createVNode(Item, {
                            item: item
                        }, null, 8 /* PROPS */, ["item"])
                    ]),
                    bottom: _withCtx(() => _cache[1] || (_cache[1] = [])),
                    _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["no-data-text", "items", "items-per-page", "headers", "sort-by"]),
                _createVNode(BrgPagination, {
                    modelValue: pageComputed.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((pageComputed).value = $event)),
                    length: getterPaginationData.value.pages
                }, {
                    start: _withCtx(() => _cache[2] || (_cache[2] = [])),
                    end: _withCtx(() => [
                        _createCommentVNode(" pageSize filter "),
                        _createVNode(Select, {
                            class: "page-size-wrapper mini",
                            value: filterOption.value.pageSizeType,
                            items: _unref(pageSizeOptionList),
                            "on-change": handleChangeSelect('pageSizeType')
                        }, null, 8 /* PROPS */, ["value", "items", "on-change"])
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue", "length"])
            ]));
        };
    }
});
